import React, {useState, useEffect} from 'react';
import {Button} from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';

let DeleteConfirmButton = (props) => {
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {setDisabled(props.disabled)}, [props.disabled]);

  const handleDeleteClick = () => {
    confirmAlert({
      title: props.title,
      message: gettext('Вы уверены, что хотите сделать это?'),
      buttons: [
        {
          label: gettext('Да'),
          onClick: async () => {
            setDisabled(true);
            await props.onDeleteClick(props.id);
            setDisabled(false);
          }
        },
        {
          label: gettext('Нет'),
          onClick: () => {}
        }
      ]
    });
  };

  return <Button variant={ props.variant ? props.variant : 'outline-dark' }
                 size="sm"
                 title={ props.title }
                 disabled={ disabled }
                 onClick={ handleDeleteClick }>
    <span className="icon icon-trash-empty"></span>
    <span className={ props.withoutTitle ? 'd-md-none' : '' }> { props.title } { props.checkedCount && <span>({ props.checkedCount })</span> }</span>
  </Button>
};
export default DeleteConfirmButton;
